import stock from "../generated/stock.json";

/**
 * The stock style for a view (docs/views.md#13-templates-and-system-views): the runtime gives every view Coast's
 * stylesheet and kit, ahead of its own styles, so views carry no copies and follow the style as it improves. A view
 * whose manifest says `"style": "own"` gets neither. A source that already has them (a view made before 2026-10-10,
 * which carries a copy) or links them the old way (`<link rel="stylesheet" href="coast.css">`,
 * `<script src="coast-kit.js">`) is served as one with them, once.
 */
export function withStock(html: string, style: "coast" | "own"): { html: string; head: string } {
  const linked = html.split(stock.styleLink).join("").split(stock.kitScript).join("");
  if (style === "own") return { html: linked, head: "" };
  const head =
    (html.includes("data-coast-style") ? "" : `<style data-coast-style>\n${stock.style}</style>`) +
    (html.includes("data-coast-kit") ? "" : `<script data-coast-kit>\n${stock.kit}</script>`);
  return { html: linked, head };
}
